import React, { useState, useEffect, FormEvent, ChangeEvent } from 'react';
import axios from "axios";
import { baseUrl } from '../../../Utils/Baseurl/Baseurl';
import { toast } from 'react-toastify';
import { Button, Input, Label, Form, FormGroup, Col, Card } from 'reactstrap';

interface Department {
  id: number;
  departmentname: string;
}

export default function Division() {
  const [formData, setFormData] = useState({ departmentname: '' });
  const [departments, setDepartments] = useState<Department[]>([]);
  const [editingDept, setEditingDept] = useState<Department | null>(null);

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const response = await axios.get(`${baseUrl}department/findAlldepartment`);
      setDepartments(response.data.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, departmentname: e.target.value });
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.departmentname.trim()) {
      toast.error("Please enter a division name.");
      return;
    }

    try {
      if (editingDept) {
        await axios.put(`${baseUrl}department/updateDepartment/${editingDept.id}`, {
          departmentname: formData.departmentname,
        });
        toast.success("Department updated successfully!");
      } else {
        await axios.post(`${baseUrl}department/createdepartment`, {
          departmentname: formData.departmentname,
        });
        toast.success("Department created successfully!");
      }
      setFormData({ departmentname: "" });
      setEditingDept(null);
      fetchDepartments();
    } catch (error) {
      toast.error("Error saving department.");
    }
  };

  const handleEdit = (dept: Department) => {
    setFormData({ departmentname: dept.departmentname });
    setEditingDept(dept);
  };

  const handleDelete = async (id: number) => {
    if (window.confirm("Are you sure you want to delete this department?")) {
      try {
        await axios.delete(`${baseUrl}department/deleteDepartment/${id}`);
        toast.success("Department deleted successfully!");
        fetchDepartments();
      } catch (error) {
        toast.error("Error deleting department.");
      }
    }
  };

  return (
    <Col sm={12}>
      <Card>
        <Form className="theme-form col-6 m-5" onSubmit={handleSubmit}>
          <FormGroup>
            <Label>Division Name <span style={{ color: "red" }}>*</span></Label>
            <Input
              type="text"
              name="departmentname"
              value={formData.departmentname}
              onChange={handleInputChange}
              placeholder="Enter division name"
              required
            />
          </FormGroup>
          <FormGroup className="mb-0">
            <Button color="primary" className="w-100 mt-3" type="submit">
              {editingDept ? "Update Division" : "Create Division"}
            </Button>
          </FormGroup>
        </Form>

        <h4 className="mt-4">Assigned Divisions</h4>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Sl.No</th>
                <th>Division</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {departments.length > 0 ? (
                departments.map((dept: Department, index) => (
                  <tr key={dept.id}>
                    <td>{index + 1}</td>
                    <td>{dept.departmentname}</td>
                    <td>
                      <Button color="warning" size="sm" onClick={() => handleEdit(dept)}>Edit</Button>{' '}
                      <Button color="danger" size="sm" onClick={() => handleDelete(dept.id)}>Delete</Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="text-center">No divisions found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </Col>
  );
}
